import { effect } from '../signals.js';
import {
  cocktailCount,
  filteredCount,
  searchTerm,
  loading,
  favoritesCount,
  showFavoritesOnly,
  toggleFavoritesFilter
} from '../cocktail-state.js';
import { Log } from '../logger.js';
import { Validator } from '../validation.js';

const _log = Log('cocktail-stats.js');

class CocktailStats extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    _log.green('Stats component connected');
    this.setupEventListeners();
    this.setupReactiveEffects();
  }

  setupEventListeners() {
    this.addEventListener('click', this.handleClick);
  }

  handleClick = (event) => {
    const favoritesButton = event.target.closest('.favorites-filter-button');
    if (favoritesButton) {
      event.preventDefault();
      toggleFavoritesFilter();
    }
  }

  setupReactiveEffects() {
    // React to search, filter, and favorites changes
    effect(() => {
      const total = cocktailCount.value;
      const filtered = filteredCount.value;
      const search = searchTerm.value;
      const isLoading = loading.value;
      const favorites = favoritesCount.value;
      const filteringFavorites = showFavoritesOnly.value;

      this.renderStats(total, filtered, search, isLoading, favorites, filteringFavorites);
    });
  }

  renderStats(total, filtered, search, isLoading, favorites, filteringFavorites) {
    if (isLoading) {
      this.innerHTML = '<div class="stats loading">Loading stats...</div>';
      return;
    }

    // Build search info with escaped user input using centralized escapeHtml
    let searchInfo;
    if (filteringFavorites && search) {
      const escapedSearch = Validator.escapeHtml(search);
      searchInfo = `Showing ${filtered} cocktails for "${escapedSearch}"`;
    } else if (filteringFavorites) {
      searchInfo = `Showing ${filtered} favorite cocktails`;
    } else if (search) {
      const escapedSearch = Validator.escapeHtml(search);
      searchInfo = `Showing ${filtered} of ${total} cocktails for "${escapedSearch}"`;
    } else {
      searchInfo = `Showing all ${total} cocktails`;
    }

    const favoritesButtonText = favorites === 0
      ? 'No favorites yet'
      : favorites === 1
        ? '1 favorite'
        : `${favorites} favorites`;

    const buttonClass = `favorites-filter-button ${filteringFavorites ? 'active' : ''}`;
    const buttonTitle = filteringFavorites
      ? 'Show all cocktails'
      : 'Show only favorites';

    this.innerHTML = `
      <div class="stats">
        <div class="search-info">${searchInfo}</div>
        <div class="action-info">
          <button class="${buttonClass}" type="button" title="${buttonTitle}" ${favorites === 0 ? 'disabled' : ''}>
            <svg width="16" height="16" viewBox="0 0 24 24" fill="${filteringFavorites ? 'currentColor' : 'none'}" stroke="currentColor" stroke-width="2">
              <polygon points="12,2 15.09,8.26 22,9.27 17,14.14 18.18,21.02 12,17.77 5.82,21.02 7,14.14 2,9.27 8.91,8.26"></polygon>
            </svg>
            <span>${favoritesButtonText}</span>
          </button>
        </div>
      </div>
    `;
  }
}

customElements.define('cocktail-stats', CocktailStats);
